'use client'

import { Box, styled } from '@mui/material'

export const StyledSwoosh = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})(({ theme, color }) => ({
  position: 'relative',
  boxSizing: 'border-box',
  minHeight: '105px',
  display: 'flex',
  width: `calc(100% + ${theme.spacing(3)})`,
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(1, 5),
  margin: theme.spacing(8, 'auto'),
  transform: `translateX(${theme.spacing(-3)})`,
  textAlign: 'left',
  backgroundColor: theme.palette[color]?.main || color,
  borderRadius: theme.spacing(0, 10, 10, 0),

  [theme.breakpoints.up('md')]: {
    '&:not(.flat)': {
      padding: theme.spacing(3, 5),
      textAlign: 'center',
      transform: 'none',
      width: '100%',
      minWidth: '336px',
      maxWidth: '800px',
      borderRadius: theme.spacing(10),
    },
  },
}))
